const REQUIRED_AUTH0_ENV = ['VITE_AUTH0_DOMAIN', 'VITE_AUTH0_CLIENT_ID', 'VITE_AUTH0_AUDIENCE'] as const;

export function getMissingAuth0EnvVars(): string[] {
  return REQUIRED_AUTH0_ENV.filter((name) => {
    const value = import.meta.env[name];
    return !value || value === 'undefined';
  });
}

export function hasRequiredAuth0Env(): boolean {
  return getMissingAuth0EnvVars().length === 0;
}
